/** This helper is necessary to improve user experience of user selection.
 * Several browsers (Chrome, Firefox, but Safari shows) don't show changes on screen
 * when selection gets adjacent node. But technically it changed.
 * So this helper calculate next or previous editable element and set correct selection */

import { isOneOfTags, isTag } from 'anodum';
import findLastTextNode from './find-last-text-node';
import findFirstTextNode from './find-first-text-node';
import { EDITABLE_ELEMENTS } from '../constants/editable-elements';
import findClosestEditableElement from './find-closest-editable-element';
import isLastTextNodeOfElement from '../verifiers/is-last-text-node-of-element';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import findRootEditableElement from './find-root-editable-element';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';

const handleAdjacentNode = () => {
  const selection = getAdvancedSelection();
  const { anchorNode, focusNode, anchorOffset, focusOffset, isCollapsed } = selection;

  if (isCollapsed || !anchorNode || !focusNode) return [];

  const range = selection.getRangeAt(0);
  const editableElements = range.getNodes([Node.ELEMENT_NODE], (el) =>
    isOneOfTags(el, EDITABLE_ELEMENTS)
  );

  if (!editableElements.length) return [];

  let leftNode = anchorNode;
  let leftOffset = anchorOffset;
  let rightOffset = focusOffset;
  if (selection.isBackwards()) {
    leftNode = focusNode;
    leftOffset = focusOffset;
    rightOffset = anchorOffset;
  }

  let rightElement = editableElements[editableElements.length - 1];
  let leftElement = editableElements[0];

  if (rightOffset === 0) {
    const rightRootElement = findRootEditableElement(rightElement);

    if (rightElement) {
      rightElement = editableElements[editableElements.indexOf(rightRootElement) - 1];
      const lastTextNode = findLastTextNode(rightElement);

      if (lastTextNode) {
        selection.setEnd(lastTextNode, lastTextNode.length);
      }
    }
  }

  if (selection.isCollapsed) {
    return [findRootEditableElement(rightElement), findRootEditableElement(rightElement)];
  }
  const leftContainer = findClosestEditableElement(leftNode);
  if (
    leftContainer &&
    isLastTextNodeOfElement(leftNode, leftContainer) &&
    leftNode.length === leftOffset
  ) {
    leftElement = editableElements[editableElements.indexOf(leftContainer) + 1];

    if (leftElement && !isTag(leftElement, IMAGE_SELECTOR)) {
      selection.setStart(findFirstTextNode(leftElement) || leftElement.querySelector('br'), 0);
    }
  }
  return [leftElement, findRootEditableElement(rightElement)];
};

export default handleAdjacentNode;
